export default "__VITE_ASSET__BMDQA9Ij__"